import _regenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import StandardTableVue from '../../../components/table/StandardTable.vue';
import { getGoodsGroupedList, deleteGoodsGroupedByid } from '@/services/product/goodsGrouped.js';
import moment from 'moment';
export default {
  components: {
    StandardTableVue: StandardTableVue
  },
  i18n: require("./i18n-group"),
  data: function data() {
    var _this = this;
    var columns = [{
      dataIndex: 'groupName',
      title: this.$t('account.groupName')
    }, {
      title: this.$t('account.goodsCount'),
      dataIndex: 'productTotal'
    }, {
      title: this.$t('account.createUser'),
      dataIndex: 'createUserName'
    }, {
      title: this.$t('account.updateTime'),
      dataIndex: 'lastUpdateTime'
      // scopedSlots: { customRender: 'lastUpdateTime' },
    }, {
      title: this.$t('emailAction'),
      dataIndex: 'action',
      scopedSlots: {
        customRender: 'action'
      }
    }];
    return {
      search: {
        title: '',
        content: ''
      },
      data: [],
      columns: columns,
      moment: moment,
      loadingTable: false,
      pagination: {
        pageSizeOptions: ['10', '20', '30'],
        total: 4,
        showTotal: function showTotal(total, r) {
          return "".concat(_this.$t('account.total')).concat(total);
        },
        pageSize: 10,
        current: 1,
        showSizeChanger: true
      },
      queryLoading: false
    };
  },
  mounted: function mounted() {
    this.initData();
  },
  methods: {
    initData: function initData() {
      var _arguments = arguments,
        _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var query, params, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              query = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;
              _this2.loadingTable = true;
              _this2.queryLoading = true;
              params = _this2.getParams(1, query);
              if (query) {
                _this2.pagination.current = 1;
              }
              _context.n = 1;
              return getGoodsGroupedList(params);
            case 1:
              res = _context.v;
              try {
                if (res.data.code == 200) {
                  _this2.data = res.data.data.list;
                  _this2.pagination.total = res.data.data.total;
                }
              } catch (_unused) {} finally {
                _this2.loadingTable = false;
                _this2.queryLoading = false;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    getParams: function getParams(info, query) {
      var params = {
        groupName: this.search.title,
        productInfo: this.search.content,
        page: query ? 1 : this.pagination.current,
        size: this.pagination.pageSize,
        scene: info
      };
      return params;
    },
    add: function add() {
      this.$router.push({
        path: 'addGoodsGrouped'
      });
    },
    Edit: function Edit(row) {
      this.$router.push({
        path: 'editGoodsGrouped',
        query: {
          groupId: row.groupId
        }
      });
    },
    // deleteGroup() {
    //     console.log(111)
    // },
    confirmDelete: function confirmDelete(row) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              // 调用删除商品分组的接口
              _this3.loadingTable = true;
              _context2.n = 1;
              return deleteGoodsGroupedByid(row.groupId);
            case 1:
              res = _context2.v;
              if (res.data.code == 200) {
                _this3.$message.success(_this3.$t('public.deleteSuccessfully'));
                // 重新获取列表
                _this3.initData();
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    cancelDelete: function cancelDelete() {},
    changePage: function changePage(e) {
      this.pagination.current = e.current;
      this.pagination.pageSize = e.pageSize;
      this.initData();
    },
    showSizeChange: function showSizeChange(e) {
      this.pagination.current = e.current;
      this.pagination.pageSize = e.pageSize;
      this.initData();
    },
    // 搜索商品
    queryData: function queryData() {
      // 调用列表接口
      this.initData(true);
    }
  }
};